import styled from '@emotion/styled'

import TemplateHeader from '@/components/templates/TemplateHeader'
import { TemplateButton } from '@/components/templates/TemplateButton'
import TemplateHero from '@/components/templates/TemplateHero'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'

const Layout = styled.section``

Layout.Header = styled(TemplateHeader)`
  display: flex;
  height: 80px;
  width: 100%;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
`

Layout.Link = styled.span`
  margin-left: 10px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 15px;
`

Layout.Hero = styled(TemplateHero)`
  width: 100%;
`

Layout.HeroContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
  min-height: calc(var(--preview-height) - 80px);
  max-height: calc(var(--preview-height) - 80px);
`

Layout.TitleContainer = styled.div`
  display: flex;
  flex-basis: 50%;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  padding-right: 65px;
`

Layout.Title = styled.h1`
  font-size: 64px;
  font-weight: 700;
  text-transform: uppercase;
`
Layout.Subtitle = styled.p`
  margin: 1em 0;
  font-size: 22px;
`
Layout.CTA = styled(TemplateButton)`
  width: fit-content;
  font-size: 16px;
  font-weight: 700;
  padding: 12px 25px;
  border-radius: 0;
  margin-top: 2em;
`
Layout.HeroImageContainer = styled.div`
  overflow: hidden;
  height: 100%;
  width: 670px;
`
export default Layout
